import { purpleBtn } from '../ui'

/**
 * The `/verify?token=…` landing: a button, not an auto-redeem.
 *
 * The magic link is single-use, and the page used to POST it to
 * /api/portal/tenant/verify from a mount effect. Corporate mail gateways open
 * every link in a headless browser before the recipient sees the message, and
 * a headless browser runs mount effects. So the gateway spent the token and the
 * person got "invalid or expired" or, if the email was held, nothing at all.
 *
 * That is not hypothetical. SOLIS (Greystar, 2026-09-03): the link to Agnesa
 * Baftija was delivered at 14:29:22Z; at 14:30:00Z a Linux Chrome 124 on an AWS
 * address loaded /verify with her token; the account was stamped "signed in" at
 * 14:30:01Z. She never saw the email. Scanners load pages; they do not press
 * buttons, so the redeem waits for a person to press one.
 *
 * Deliberately no auto-continue for any case, including the ops "sign in as
 * tenant" link: the page cannot tell which kind of token it holds without
 * redeeming it, which is the thing it must not do on load.
 */
export function ConfirmSignInLink({ busy, onContinue }: { busy: boolean; onContinue: () => void }) {
  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24, background: 'var(--color-gate-field, #F8F7F9)' }}>
      <div style={{ width: '100%', maxWidth: 420, background: '#fff', borderRadius: 16, padding: '36px 36px 30px', border: '1px solid var(--color-gray-300, #ECE9EF)', boxShadow: '0 12px 32px rgba(35,31,32,0.10), 0 2px 8px rgba(35,31,32,0.05)', textAlign: 'center' }}>
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <img src="/parkify-logo-color.svg" alt="Parkify" style={{ height: 24, width: 'auto', display: 'block' }} />
        </div>
        <div className="signin-product">TENANT PORTAL</div>
        <h1 style={{ fontSize: 24, fontWeight: 800, margin: '0 0 4px' }}>Continue to your portal</h1>
        <p style={{ fontSize: 13, color: 'var(--color-gray-600)', margin: '0 0 24px', lineHeight: 1.5 }}>
          Your sign-in link is ready. Press the button to open the portal.
        </p>
        <button type="button" onClick={onContinue} disabled={busy} style={{ ...purpleBtn, width: '100%', padding: '12px 16px', fontSize: 14, opacity: busy ? 0.7 : 1 }}>
          {busy ? 'Signing you in…' : 'Continue to portal'}
        </button>
      </div>
    </div>
  )
}
